import { DOMSerializer, Node as ProseMirrorNode, } from "prosemirror-model";
import { generateSchema } from "../core/extension";
import { defaultMarkdownSerializer, MarkdownSerializer, } from "prosemirror-markdown";
import { markdownItTable } from "markdown-it-table";
import MarkdownIt from "markdown-it";
/**
 * Serialize a document to an HTML node.
 */
export function serializeToNode(doc, extensions) {
    const schema = generateSchema(extensions);
    const serializer = DOMSerializer.fromSchema(schema);
    const node = ProseMirrorNode.fromJSON(schema, doc);
    return serializer.serializeFragment(node);
}
/**
 * Serialize a ProseMirror node to an HTML node.
 */
export function serializeNodeFromSchema(node, schema) {
    const serializer = DOMSerializer.fromSchema(schema);
    return serializer.serializeFragment(node);
}
/**
 * Serialize a document to a raw HTML string.
 */
export function serializeToHTML(doc, extensions) {
    const node = serializeToNode(doc, extensions);
    const tempDiv = document.createElement("div");
    tempDiv.appendChild(node);
    return tempDiv.innerHTML;
}
export function serializeToHTMLFromSchema(doc, schema) {
    const node = serializeNodeFromSchema(doc, schema);
    const tempDiv = document.createElement("div");
    tempDiv.appendChild(node);
    return tempDiv.innerHTML;
}
const markdownSerializerTableTokens = {
    image(state, node) {
        // Ignores images during serialization.
        return "\n";
    },
    table(state, node) {
        let addedSeparator = false;
        // state.renderContent(node);
        for (let i = 0; i < node.childCount; i++) {
            const child = node.child(i);
            if (child.type.name === "table_row" &&
                child.firstChild.type.name === "table_header") {
                if (!addedSeparator) {
                    state.write("| ");
                    for (let j = 0; j < child.childCount; j++) {
                        state.render(child.child(j));
                        state.write(" | ");
                    }
                    state.write("\n");
                    state.write("| ");
                    for (let j = 0; j < child.childCount; j++) {
                        state.write("---");
                        state.write(" | ");
                    }
                    state.write("\n");
                    addedSeparator = true;
                }
            }
            else {
                state.write("| ");
                for (let j = 0; j < child.childCount; j++) {
                    state.render(child.child(j));
                    state.write(" | ");
                }
                state.write("\n");
            }
            state.render(child);
            state.write("\n");
        }
        state.closeBlock(node);
    },
    table_row(state, node) {
        // no need to handle, handled by table serializer
    },
    table_header(state, node) {
        // we just need to inline-render whatever is inside
        // the table will take care of the rest
        if (node.firstChild.type.name === "paragraph") {
            state.renderInline(node.firstChild);
        }
    },
    table_cell(state, node) {
        // we just need to inline-render whatever is inside
        // the table will take care of the rest
        if (node.firstChild.type.name === "paragraph") {
            state.renderInline(node.firstChild);
        }
    },
};
export function serializeNodeToMarkdown(node, schema) {
    const md = new MarkdownIt();
    md.use(markdownItTable);
    const serializer = new MarkdownSerializer(Object.assign({}, defaultMarkdownSerializer.nodes, markdownSerializerTableTokens), defaultMarkdownSerializer.marks);
    return serializer.serialize(node, {
        tightLists: true,
    });
}
